import { gql } from "@apollo/client";

export const GET_MAIN_MENU = gql`
  query {
    getMainMenu {
      code
      label
      description
      url_route
      permission_name
    }
  }
`;

export const GET_MENU_ITEMS = gql`
  query GetMenuItems {
  getMenuItems {
    sections {
      code
      label
      description
      url_route
      permission_name
      selected_system_required_before_routing
      route_option
      use_react_routing
      children {
        code
        label
        description
        url_route
        permission_name
        selected_system_required_before_routing
        route_option
        use_react_routing
        children {
          code
          description
          label
          permission_name
          selected_system_required_before_routing
          route_option
          use_react_routing
          url_route
        }
      }
    }
  }
}
`;